export const progress = (promises, callback) => {
  const len = promises.length;
  let progress = 0;

  const tick = async (promise) => {
    await promise;

    progress++;

    callback(progress, len);

    return promise;
  };

  return Promise.all(promises.map(tick));
};
